import React from "react";

function App() {
  return (
    <div>
      <header>Mango Hiccups</header>
    </div>
  );
}

export default App;
